module.exports = __webpack_public_path__ + "img/pic.0d3b4b8.png";